import { PropertyStatus } from "../../models/property";
import { Tabs } from "../UI/Tabs/Tabs";
// @ts-expect-error pure js
import usePropertyFolders from "../../hooks/use-property-folders";
import PropertyList from "./PropertyList";
import {
  buildPropertyFoldersTree,
  filterPropertiesAndFoldersByStatus,
  // @ts-expect-error pure js
} from "../../utils/properties";
import type { Property } from "../../models/property";
import type { PropertyFolder } from "../../models/propertyFolder";

export const ROOT_PATH = "/bailleur/properties/";

export interface PropertiesAndFolders {
  properties?: Property[];
  property_folders?: PropertyFolder[];
}

interface PropertyListShowProps {
  properties: Property[];
  onDuplicateProperty: (property: Property) => Promise<void>;
  onAdd?: () => void;
  isLoading: boolean;
}

export default function PropertyListShow({
  properties,
  onDuplicateProperty,
  onAdd,
  isLoading,
}: PropertyListShowProps) {
  const { propertyFolders, isLoading: isLoadingFolder } = usePropertyFolders();

  const propertiesAndFolders: PropertiesAndFolders = buildPropertyFoldersTree(
    propertyFolders,
    properties,
  );

  const tousMesBiens: PropertiesAndFolders = filterPropertiesAndFoldersByStatus(
    propertiesAndFolders,
    PropertyStatus.Actif.status,
  );
  const archivedProperties = properties.filter(
    (property) => property.status === PropertyStatus.Archive.status,
  );
  const archive: PropertiesAndFolders = filterPropertiesAndFoldersByStatus(
    propertiesAndFolders,
    PropertyStatus.Archive.status,
  );

  return (
    <Tabs id="prop-list" defaultValue="tous-mes-biens">
      <div className="container bg-blue paddingT10 border-blue">
        <div className="content">
          <Tabs.List>
            <Tabs.Tab value="tous-mes-biens">Tous mes biens</Tabs.Tab>
            <Tabs.Tab value="archives">
              Biens archivés ({archivedProperties.length})
            </Tabs.Tab>
          </Tabs.List>
        </div>
      </div>
      <div className="blueSpace"></div>
      <div className="content">
        <Tabs.Panel value="tous-mes-biens">
          <PropertyList
            propertiesAndFolders={tousMesBiens}
            onDuplicateProperty={onDuplicateProperty}
            onAdd={onAdd}
            addLabel="Ajouter un bien"
            isLoading={isLoading || isLoadingFolder}
          />
        </Tabs.Panel>
        <Tabs.Panel value="archives">
          <PropertyList
            propertiesAndFolders={archive}
            onDuplicateProperty={onDuplicateProperty}
            isLoading={isLoading || isLoadingFolder}
          />
        </Tabs.Panel>
      </div>
    </Tabs>
  );
}
